import { useRef, useCallback } from 'react';
import gsap from 'gsap';

export const useLiquidEffect = () => {
  const elementRef = useRef<HTMLButtonElement>(null);

  const triggerLiquid = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    if (!elementRef.current) return;

    const button = elementRef.current;
    const rect = button.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Create ripple element
    const ripple = document.createElement('span');
    ripple.className = 'liquid-ripple';
    ripple.style.cssText = `
      position: absolute;
      left: ${x}px;
      top: ${y}px;
      width: 0;
      height: 0;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(212,175,55,0.6) 0%, rgba(212,175,55,0) 70%);
      pointer-events: none;
      transform: translate(-50%, -50%);
    `;

    button.appendChild(ripple);

    // Animate ripple
    gsap.to(ripple, {
      width: rect.width * 2.5,
      height: rect.width * 2.5,
      opacity: 0,
      duration: 0.8,
      ease: 'power2.out',
      onComplete: () => ripple.remove(),
    });

    // Button squeeze effect
    gsap.timeline()
      .to(button, {
        scale: 0.95,
        duration: 0.1,
        ease: 'power2.in',
      })
      .to(button, {
        scale: 1,
        duration: 0.3,
        ease: 'elastic.out(1, 0.3)',
      });

  }, []);

  return { elementRef, triggerLiquid };
};
